import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BranchLookUpService from 'services/branchLookupServices';
import { formatValidationErrors } from 'utils/ArrayUtils';

export const initialState = {
    list : [],
    fetching: false,
    creating: false,
    updating : false,
    deleting : false,
    errorMessages: [],
    showMessage: false,
    showEditForm : false,
    showNewForm : false,
    loading: false,
    error: null,
}

export const fetchBranchLookups = createAsyncThunk('/fetchBranchLookups', async (data, {rejectWithValue }) => {
    try {
            const response = await BranchLookUpService.fetch();
            var code = response.code;	
            return {
                code: code,
                branchs : response.data
            };
    } catch (err) {
        let code = err.response?.data.code;
        let response = err.response;
        return rejectWithValue({
            code: code,
            errorMessages: response?.data?.message || 'Error'
        });
    }
});

export const createBranchLookups = createAsyncThunk('/createBranchLookups',async (data, { rejectWithValue }) => {
    try {
        const response = await BranchLookUpService.create(data)
        const code  = response.original.code;
        return {
            code: code,
            branchs : response.original.data
        };
    } catch (err) {
        return rejectWithValue({code : err.response.status, error : err.response?.data.errors} || {error : "Error creating a branch"})
    }
})

export const updateBranchLookups = createAsyncThunk('/updateBranchLookups',async (data, { rejectWithValue }) => {
    try {
        const response = await BranchLookUpService.update(data)
        const code = response.original.code;
        return {
            code: code,
            branchs : response.original.data
        };
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const deleteBranchLookups = createAsyncThunk('/deleteBranchLookups',async (id, { rejectWithValue }) => {
    try {
        const response = await BranchLookUpService.delete(id)
        const code = response.original.code;
        return {
            code: code,
            branchs : response.original.data
        };
    } catch (err) {
        return rejectWithValue({error : "Error deleting a branch"})
    }
})

export const branchLookUpSlice = createSlice({
    name: 'branchLookups',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.fetching = !state.fetching
        },
        toggleBranchsEditForm : (state) => {
            state.showEditForm =  !state.showEditForm;
        },
        toggleBranchsNewForm : (state) => {
            state.showNewForm  = !state.showNewForm        
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBranchLookups.pending, (state) => {
                state.fetching = true
            })
            .addCase(fetchBranchLookups.fulfilled, (state, action) => {
                state.fetching = false
                // console.log('action.payload.branchs', action.payload.branchs)
                state.list = action.payload.branchs
            })
            .addCase(fetchBranchLookups.rejected, (state, action) => {
                state.fetching = false
            })
            .addCase(createBranchLookups.pending, (state) => {
                state.creating = true
            })
            .addCase(createBranchLookups.fulfilled, (state, action) => {
                state.creating = false
                state.list = action.payload.branchs
                state.showNewForm = !state.showNewForm;
            })
            .addCase(createBranchLookups.rejected, (state, action) => {
                if(action.payload.code == 422){
                    state.errorMessages = formatValidationErrors(action.payload.error)
                }
                else {
                    // state.errorMessages = action.payload.error;
                }
                state.creating = false;
            })
            .addCase(updateBranchLookups.pending, (state, action) => {
                state.updating = true
            })
            .addCase(updateBranchLookups.fulfilled, (state, action) => {
                state.updating = false
                state.list = action.payload.branchs
                state.showEditForm = !state.showEditForm
            })
            .addCase(updateBranchLookups.rejected, (state, action) => {
                state.errorMessages = action.payload
                state.updating = false
            })
            .addCase(deleteBranchLookups.pending, (state, action) => {
                state.deleting = true
            })
            .addCase(deleteBranchLookups.fulfilled, (state, action) => {
                state.deleting = false
                state.list = action.payload.branchs
            })
            .addCase(deleteBranchLookups.rejected, (state, action) => {
                state.deleting = false
            })
    },
})

export const { 
    showLoading,
    toggleBranchsEditForm,
    toggleBranchsNewForm
} = branchLookUpSlice.actions

export default branchLookUpSlice.reducer